import { Grid } from "@material-ui/core";
import React from "react";
import { Col, Row } from "react-bootstrap";

//Wording within image carousel

class WhatWeDo extends React.Component {
  render() {
    return (
      <>
        <div className="container testCSS">
          <div className="spacingWeDo" id="more">
            <div className="weDoTitle servicesArea" data-aos={"fade"}>
              Building from passion
            </div>
            <div className="weDo servicesArea" data-aos={"fade"}>
              We enhance a company's online presence by offering them top
              quality custom mobile and web apps. We are fully design driven and
              love to create things that are nice to look at. By employing the
              design first technique to every single detail of our apps, we
              create a compelling product capable of satisfying our clients and
              the end user.
            </div>
          </div>

          <Grid container spacing={2}>
            <Grid item md={4} xs={12}>
              <div className="weDoTitle servicesArea" data-aos={"fade"}>
                <img
                  src="https://do1pg20gb8r9m.cloudfront.net/Headshot_Brandon.jpg"
                  className="imageBrandon"
                />
              </div>
            </Grid>
            <Grid item md={8} xs={12}>
              <div className="weDoTitle servicesArea" data-aos={"fade"}>
                Meet the Developer
              </div>
              <div className="weDo servicesArea" data-aos={"fade"}>
                Hello 👋 , I'm Brandon Caiza (24 year old, CS @ UBC), passionate
                about computer science and entreprenuership. I have skills in
                mobile and web development, but also like to work on Data
                projects.
                <br></br>
                <br></br>I want to continue developing my skills in computer
                science and have fun doing so!
              </div>
            </Grid>
          </Grid>
        </div>
      </>
    );
  }
}

export default WhatWeDo;
